export const PRIMARY_NAV_ITEMS = [
  { name: "home", alt: "Home", path: "/" },
  { name: "projects", alt: "Projects", path: "/projects" },
  { name: "tools", alt: "Tools", path: "/tools" },
  { name: "experience", alt: "Experience", path: "/experience" },
  { name: "contact", alt: "Contact", path: "/contact" },
];
